const STATION_TYPE = {
  ALBUM: 'album',
  MY_MUSIC: 'mymusic',
};

export default STATION_TYPE;
